import {WebStorageStateStore} from 'oidc-client';

export const Settings = {
    authority: `${environmentSettings.authUrl}`,
    client_id: 'my-spare-parts-ui',
    redirect_uri: `${environmentSettings.websiteUrl}/login`,
    post_logout_redirect_uri: `${environmentSettings.websiteUrl}/logout?success=true`,
    response_type: 'id_token token',
    scope: 'openid profile email spare-parts-api',
    filterProtocolClaims: true,
    loadUserInfo: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    siteInfoStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    silent_redirect_uri: `${environmentSettings.websiteUrl}/SilentRenew`
};
